// ReactJs
import React from 'react'
// Node modules
import styled from 'styled-components'
// Layouts
import WelcomePageLink from './WelcomePageLink'

const WelcomePageLinksContainer = styled.div`
  margin-top: 35px;
`

export default function WelcomePageLinks({ ...props }) {
  return (
    <WelcomePageLinksContainer>
      <WelcomePageLink label="J’ai une question ?" path="/faq" />
      <WelcomePageLink label="Mes coordonnées" path="/contactInformation" />
    </WelcomePageLinksContainer>
  )
}
